// api constants for the application

// authentication endpoints
const AUTH = 'AUTH/'

export const AUTH_ENDPOINTS = {
    ANNOUNCEMENTS: `${AUTH}announcements`,
    LOGIN: `${AUTH}login`,
    // Add more endpoints as needed
}

// account endpoints
const ACCOUNT = 'account/'

export const ACCOUNT_ENDPOINTS = {
    ACCOUNT: `${ACCOUNT}`,
    UPDATEPROFILE: `${ACCOUNT}UpdateProfile`,
    UPDATESECURITYQUESTIONS: `${ACCOUNT}UpdateSecurityQuestions`,
    UPDATEPASSWORD: `${ACCOUNT}UpdatePassword`,
    // Add more endpoints as needed
}

// registration endpoints
const REGISTER = 'Register/'

export const REGISTER_ENDPOINTS = {
    REGISTER: `${REGISTER}`,
    GETALLSUFFIX: `${REGISTER}getAllSuffix`,
    CONFIRMEMAIL: `${REGISTER}ConfirmEmail?email=`,
    VERIFYSECURITYCODE: `${REGISTER}VerifySecurityCode?email=`,
    REGISTERUSER: `${REGISTER}RegisterUser`,
    // Add more endpoints as needed
}

// loginQA endpoints

const LOGINQA = 'LoginQA/'

export const LOGINQA_ENDPOINTS = {
    ALL: `${LOGINQA}all`,
    // Add more endpoints as needed
}

// home endpoints
const HOME = 'Home/'

export const HOME_ENDPOINTS = {
    GETDLLS: `${HOME}getdlls`,
    DELETELETTER: `${HOME}deleteletter`,
    UPLOAD: `${HOME}upload`,
    DOWNLOADLETTER: `${HOME}downloadletter`,
    GETLETTERS: `${HOME}getletters`,
    DECLINED: `${HOME}declined?letterId=`,
    // Add more endpoints as needed
}

// letterRequestEmail endpoints
const LETTERREQUESTEMAIL = 'LetterRequestEmail/'

export const LETTERREQUESTEMAIL_ENDPOINTS = {
    LETTERREQUESTEMAIL: `${LETTERREQUESTEMAIL}`,
    // Add more endpoints as needed
}

// resetPassword endpoints
const RESETPASSWORD = 'ResetPassword/'

export const RESETPASSWORD_ENDPOINTS = {
    REQUESTTELESIGNOTP: `${RESETPASSWORD}requestTelesignOTP`,
    REQUESTEMAILOTP: `${RESETPASSWORD}requestEmailOTP`,
    UPDATEPASSWORD: `${RESETPASSWORD}updatePassword`,
    VERIFYTELESIGNOTP: `${RESETPASSWORD}verifyTelesignOTP`,
    VERIFYEMAILSECURITYCODE: `${RESETPASSWORD}verifyEmailSecurityCode`,
    _2FA: `${RESETPASSWORD}2FA`,
    VERIFYSECURITYCODE: `${RESETPASSWORD}verifySecurityCode`,
    VERIFYLOGINQUESTION: `${RESETPASSWORD}verifyLoginQuestion`,
    REQUESTID: `${RESETPASSWORD}requestId`,
    // Add more endpoints as needed
}

// vetEval endpoints
const VETEVAL = 'VetEval/'

export const VETEVAL_ENDPOINTS = {
    GETFORM: `${VETEVAL}getForm?letterId=`,
    SAVEFORM: `${VETEVAL}saveForm?letterId=`,
}

// letterForm endpoints
const LETTERFORM = 'LetterForm/'

export const LETTERFORM_ENDPOINTS = {
    GETFORM: `${LETTERFORM}getForm?letterId=`,
    SAVEFORM: `${LETTERFORM}saveForm?letterId=`,
}
